import { Pipe, PipeTransform } from '@angular/core';
import { Mission } from '../../models/mission/mission';

@Pipe({
	name: 'filterMissionsByDate'
})
export class FilterMissionsByDatePipe implements PipeTransform {
	transform(missions: Mission[], dateFilter: Date): Mission[] {
		if (missions === null || dateFilter === null) {
			return missions;
		}

		return missions.filter((mission: Mission) => {
			if (mission.missionRequest !== null) {
				return (
					new Date(mission.missionRequest.date).getDate() ===
					dateFilter.getDate()
				);
			}
			return false;
		});
	}
}
